// extracted by mini-css-extract-plugin
module.exports = {"badge":"StoreBadge_badge__3tfo_","button":"StoreBadge_button__1FvyU"};